export default "__VITE_ASSET__dT13VWka__"